import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Edit the URL's search params in place (replacing the history entry), starting from the LIVE URL.
 * React Router's own setter, even in its function form, starts from the params of the render that
 * created it, so two edits in one click (pick a building, then open its tab) would each start from
 * the same old URL and the second would drop the first. Reading `window.location` makes them stack.
 */
export const useReplaceSearchParams = (): ((edit: (params: URLSearchParams) => void) => void) => {
	const [, setSearchParams] = useSearchParams();
	return useCallback(
		(edit: (params: URLSearchParams) => void) => {
			const params = new URLSearchParams(window.location.search);
			edit(params);
			setSearchParams(params, { replace: true });
		},
		[setSearchParams],
	);
};
